import React from 'react';
import { StarIcon } from 'lucide-react';
const QUOTES = [{
  quote: 'I prepared an entire week of classes in one evening. Every session now feels structured, professional, and ready to teach.',
  name: 'Emily M.',
  location: 'London, UK'
}, {
  quote: 'The sequences are clear, easy to follow, and simple to adapt for different students. I finally feel organized before every class.',
  name: 'Sophie T.',
  location: 'Melbourne, Australia'
}, {
  quote: 'Everything I need is in one place. No more hours searching through videos, saved posts, and old notebooks.',
  name: 'Olivia R.',
  location: 'Auckland, New Zealand'
}];
export function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} aria-label="5 out of 5 stars" data-id="element-197" data-mp="2kzi345xn857m">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-brand text-brand" aria-hidden="true" data-id="element-198" data-mp="2c0woglvalac4" />)}
    </div>;
}
export function QuickTestimonials() {
  return <section aria-label="Instructor quotes" className="w-full bg-ivory px-4 pb-10 sm:px-6" data-id="element-199" data-mp="2pmw0dd2emzsp">
      <div className="mx-auto grid max-w-6xl gap-3 md:grid-cols-3" data-id="element-200" data-mp="2kp46idi793lv">
        {QUOTES.map(item => <figure key={item.name} className="rounded-2xl border border-brand/15 bg-white p-4 shadow-sm" data-id="element-201" data-mp="2yom2pdxtrj59">
            <Stars data-id="element-202" data-mp="260ggemr4hm3b" />
            <blockquote className="mt-2 text-sm italic leading-snug text-charcoal" data-id="element-203" data-mp="25zydj79yg9mf">
              “{item.quote}”
            </blockquote>
            <figcaption className="mt-2 font-head text-xs font-semibold text-charcoal" data-id="element-204" data-mp="220z8lmo84cuz">
              {item.name}
              <span className="block font-body font-normal text-softgray" data-id="element-205" data-mp="2fsdtjz1oyo4o">{item.location}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}